const getLocationOrigin = () => {
    //return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
    return 'https://app.gxchudian.com'
  }
  const url='https://app.gxchudian.com'
  const urlImg='https://app.gxchudian.com'
  const companyName = '触点文化'
  const version = 'V1.0.0'
  const baiduKey = '百度key'
  const cacheFix='mtx_'
  
  export default {
    url,
    version,
    companyName,
    getLocationOrigin,
    baiduKey,
    cacheFix
  }
  